<div class="mainContent">

    <div>
            <label i18n="@@spmsUserReg" class="textColour">Add Scheduler Report</label>
            <span class="example-spacer"></span>
    </div>

    <div style="height:65vh;overflow-y: scroll;overflow-x: hidden;padding: 0 40px 0 40px;">
    <form novalidate [formGroup]="FormValid">

        <div class="row topRowMargins">
            <div class="col">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@spmsUserReglastname">Report Name</mat-label>
                    <input matInput type="text" maxlength="150" formControlName="reportname"
                        [(ngModel)]="reportNameData" required>
                    <mat-error *ngFor="let validation of validation_messages.reportname">
                        <span
                            *ngIf="FormValid.get('reportname').hasError(validation.type) && (FormValid.get('reportname').dirty || FormValid.get('reportname').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col">
                <mat-form-field appearance="outline">
                    <mat-label>Report Type</mat-label>
                    <mat-select formControlName="reporttypeid"
                        [(ngModel)]="schedulerReportsData.reporttypeid"
                        (ngModelChange)="selectReportType($event)" required>
                        <mat-option *ngFor="let obj of reportTypeData" [value]="obj.reporttypeid">
                            {{obj.reporttypename}}</mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.reporttypeid">
                        <span
                            *ngIf="FormValid.get('reporttypeid').hasError(validation.type) && (FormValid.get('reporttypeid').dirty || FormValid.get('reporttypeid').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col">
                <mat-form-field appearance="outline">
                    <mat-label>Report Reference</mat-label>
                    <mat-select formControlName="reportreferenceid"
                        [(ngModel)]="schedulerReportsData.reportreferenceid"
                        (ngModelChange)="selectReportReference($event)" required>
                        <mat-option *ngFor="let obj of reportReferenceData" [value]="obj.reportreferenceid">
                            {{obj.reportreferencename}}</mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.reportreferenceid">
                        <span
                            *ngIf="FormValid.get('reportreferenceid').hasError(validation.type) && (FormValid.get('reportreferenceid').dirty || FormValid.get('reportreferenceid').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col">
                <mat-form-field appearance="outline">
                    <mat-label>Products</mat-label>
                    <mat-select formControlName="productid"
                        [(ngModel)]="schedulerReportsData.productid"
                        (ngModelChange)="selectProducts($event)" required>
                        <mat-option *ngFor="let obj of productsData" [value]="obj.productid">
                            {{obj.productname}}</mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.productid">
                        <span
                            *ngIf="FormValid.get('productid').hasError(validation.type) && (FormValid.get('productid').dirty || FormValid.get('productid').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col">
                <mat-form-field appearance="outline">
                    <mat-label>Authorities</mat-label>
                    <mat-select formControlName="authoritiesid"
                        [(ngModel)]="schedulerReportsData.authoritiesid"
                        (ngModelChange)="selectAuthorities($event)" required>
                        <mat-option *ngFor="let obj of authoritiesData" [value]="obj.authoritiesid">
                            {{obj.authoritiesname}}</mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.authoritiesid">
                        <span
                            *ngIf="FormValid.get('authoritiesid').hasError(validation.type) && (FormValid.get('authoritiesid').dirty || FormValid.get('authoritiesid').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">Schedule Frequency</mat-label>
                    <mat-select formControlName="date" (selectionChange)="ChangeSelect($event)"
                        [(ngModel)]="schedulerReportsData.date">
                        <mat-option value="today">Daily</mat-option>
                        <mat-option value="currentWeek">Weekly</mat-option>
                        <mat-option value="currentMonth">Monthly</mat-option>
                        <mat-option value="currentHalfYear">Half Yearly</mat-option>
                        <mat-option value="currentYear">Yearly</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMSTAFFMASTERLastname">Start Date</mat-label>
                  <input matInput [(ngModel)]="startDatetemp" [max]="endDateTemp" [matDatepicker]="startDate" readonly required
                    formControlName="startDate">
                  <mat-datepicker-toggle matSuffix [for]="startDate">
                    <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #startDate></mat-datepicker>
                  <mat-error
                    *ngIf="FormValid.get('startDate').hasError('matDatepickerParse') && (FormValid.get('startDate').dirty || FormValid.get('startDate').touched)">
                    <span>Start Date is required</span>
                  </mat-error>
                  <mat-error
                    *ngIf="FormValid.get('startDate').hasError('required') && (FormValid.get('startDate').dirty || FormValid.get('startDate').touched)">
                    <span>Start Date is required</span>
                  </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>End Date</mat-label>
                  <input matInput [matDatepicker]="dp3" [min]="startDatetemp" [(ngModel)]="endDateTemp"
                    formControlName="endDate"readonly required>
                  <mat-datepicker-toggle matSuffix [for]="dp3">
                    <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #dp3></mat-datepicker>
                  <mat-error
                    *ngIf="FormValid.get('endDate').hasError('matDatepickerParse') && (FormValid.get('endDate').dirty || FormValid.get('endDate').touched)">
                    <span>End Date is required</span>
                  </mat-error>
                  <mat-error
                    *ngIf="FormValid.get('endDate').hasError('required') && (FormValid.get('endDate').dirty || FormValid.get('endDate').touched)">
                    <span>End Date is required</span>
                  </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@spmsUserReglastname">Schedule Time</mat-label>
                    <input matInput type="time" formControlName="scheduletime"
                        [(ngModel)]="scheduleTimeData">
                    <mat-error *ngFor="let validation of validation_messages.scheduletime">
                        <span
                            *ngIf="FormValid.get('scheduletime').hasError(validation.type) && (FormValid.get('scheduletime').dirty || FormValid.get('scheduletime').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col">
                <mat-radio-group (change)="radioChange($event)">
                    <mat-radio-button value="start" checked="true" style="width:50%;">Start</mat-radio-button>
                    <mat-radio-button value="stop" style="width:50%;">Stop</mat-radio-button>
                  </mat-radio-group>                  
            </div>
        </div>
    </form>
    </div>

    <div class="row topRowMargins">
        <div class="col">

        </div>
        <div class="col">
            <button type="button" class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;"
            (click)="SaveData()" [style.background-color]="backgroundColorButton">Save</button>
        </div>
        <div class="col">
            <button type="button" class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;" (click)="CancelData()" [style.border-color]="backgroundColorButton">Cancel</button>
        </div>
    </div>
</div>